import { api } from './client'

export type JournalKind = 'option' | 'stock' | 'no_trade'

// Server-filled (§3.3). option entries carry the contract; stock / no_trade
// carry the macro readings that were current when the note was written.
export type JournalSnapshot = {
  strike?: number
  premium?: number
  dte?: number
  iv_rank_at_open?: number
  underlying?: number
  wti?: { value: number; as_of: string }
  cpi_mom?: { value: number; as_of: string }
  core_cpi_mom?: { value: number; as_of: string }
  dgs10?: { value: number; as_of: string }
  dgs2?: { value: number; as_of: string }
  scenario?: string
  e?: number
  l?: number
}

export type JournalSettlement = {
  move_pct?: number
  ref_close?: number
  settle_close?: number
  as_of?: string
  unavailable?: boolean
  reason?: string
}

export type JournalEntry = {
  id: string
  kind: JournalKind
  symbol?: string | null
  action: string
  reason: string
  event_id?: string | null
  position_id?: string | null
  holding_id?: string | null
  snapshot: JournalSnapshot
  settle_on?: string | null
  settlement?: JournalSettlement | null
  created_at: string
}

export type JournalInput = {
  kind: JournalKind
  symbol?: string
  action: string
  reason: string
  event_id?: string
  position_id?: string
  holding_id?: string
}

export function listJournal(limit = 50, before?: string): Promise<{ items: JournalEntry[] }> {
  return api<{ items: JournalEntry[] }>(`/v1/journal?limit=${limit}${before ? `&before=${encodeURIComponent(before)}` : ''}`)
}

export function createJournalEntry(body: JournalInput): Promise<JournalEntry> {
  return api<JournalEntry>('/v1/journal', { method: 'POST', body: JSON.stringify(body) })
}

export function deleteJournalEntry(id: string): Promise<unknown> {
  return api(`/v1/journal/${id}`, { method: 'DELETE' })
}
